import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { HeaderComponent } from "./HeaderComponent"
import { FooterComponent } from "./FooterComponent"

const addUnavScriptOnce = () => {
  if (process.env.NODE_ENV === "development") return;
  if (document.getElementById("unav-script"))
  {
    return; // guard
  }
  const script = document.createElement("script");
  script.id = "unav-script";
  script.src = `${process.env.REACT_APP_TMO_UNAV_ENV}/client/unav.min.js?unav=phx`;
  script.async = true;
  script.type = "text/javascript";
  document.body.appendChild(script);
};


const getQueryVariable = (variable) => {
  const query = window.location.search.substring(1)
  const vars = query.split("&")
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split("=")
    if (pair[0] === variable) { return pair[1] }
  }
  return (false)
}

const waitForAuthCookieThenLoadUnav = () => {
  const maxWaitMs = 8000;
  const intervalMs = 100;
  const start = Date.now();

  const timer = window.setInterval(() => {
    const authed = document.cookie.includes("Authenticated=true");
    const timedOut = Date.now() - start > maxWaitMs;

    if (authed || timedOut) {
      window.clearInterval(timer);
      addUnavScriptOnce();
    }
  }, intervalMs);

  return () => window.clearInterval(timer);
};

export const LayoutComponent = ({ children }) => {
  const [hide, sethide] = useState(false)
  useEffect(() => {
    if (getQueryVariable("user_token")) {
      sethide(true);
      return;
    }

    if (document.cookie.includes("Authenticated=true")) {
      addUnavScriptOnce();
      return;
    }

    return waitForAuthCookieThenLoadUnav();
  }, []);


  return (
    <>
      {!hide && <HeaderComponent />}
      {children}
      {!hide && <FooterComponent />}
    </>
  )
}

LayoutComponent.propTypes = {
  children: PropTypes.element.isRequired
}
